<template>
  <section class="">
    <aside class="main-sidebar position-fixed bg-white border-right ">
    <!-- Brand Logo -->
    <div class="sidebar-logo py-2  trijaya-green-color">
      <router-link to="/">
        <img src="../../public/img/tri-jaya-tour.png" alt="AdminLTE Logo" class="brand-image img-circle mb-3" style="opacity: .8; width: 120px; height: 80px;">
      </router-link>
    </div>

    <!-- Sidebar -->
    <div class="sidebar trijaya-green-color pb-5 ">
      <!-- Sidebar Menu -->
      <nav class="text-left">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          
          <FixedNavbarLink to="/guest" icon="fas fa-address-book" >Guest</FixedNavbarLink>

          <!--  -->
          <div class="">
            <a  class="nav-link d-flex justify-content-between align-items-center w-full mb-0 text-light" data-bs-toggle="collapse" :data-bs-target="'#data-master'" aria-expanded="false" aria-controls="data-master">
              <div class="" style="">
                <i class="nav-icon fas fa-copy mr-2 "></i>
                  <p class="">
                    Data Master
                  </p>
              </div>
                <i class="nav-icon fas fa-angle-down"></i>
            </a>
            <div id="data-master" class="collapse pl-5 me-4" :class="{ show: isActive }">
              <FixedNavbarLink type="group" to="/destinations">Destination</FixedNavbarLink>
              <FixedNavbarLink type="group" to="/transportations">Transportation</FixedNavbarLink>
              <FixedNavbarLink type="group" to="/accommodations">Accommodation</FixedNavbarLink>
              <FixedNavbarLink type="group" to="/activities">Activity</FixedNavbarLink>
            </div>
          </div>
          <!--  -->
          <div class="">
            <a  class="nav-link d-flex justify-content-between align-items-center w-full mb-0 text-light" data-bs-toggle="collapse" :data-bs-target="'#layanan'" aria-expanded="false" aria-controls="layanan">
              <div class="" style="">
                <i class="nav-icon fas fa-suitcase-rolling mr-2 "></i>
                  <p class="">
                    Layanan
                  </p>
              </div>
                <i class="nav-icon fas fa-angle-down"></i>
            </a>
            <div id="layanan" class="collapse pl-5 me-4" :class="{ show: isActive }">
              <FixedNavbarLink type="group" to="/programs">Program</FixedNavbarLink>
              <FixedNavbarLink type="group" to="/packages">Paket</FixedNavbarLink>
            </div>
          </div>
          
          <FixedNavbarLink to="/offerdocuments" icon="fas fa-file-invoice" >Offer Document</FixedNavbarLink>
          <FixedNavbarLink to="/spj" icon="fas fa-file-signature" >Surat Perintah Jalan</FixedNavbarLink>
          <FixedNavbarLink to="/vendor" icon="fas fa-handshake" >Vendor</FixedNavbarLink>
          <FixedNavbarLink to="/vehicle" icon="fas fa-car" >Vehicle</FixedNavbarLink>
          <FixedNavbarLink to="/driverguide" icon="fas fa-users-cog">Driver & Guide</FixedNavbarLink>
          <FixedNavbarLink to="/maintenances" icon="fas fa-car-crash" >Maintenance</FixedNavbarLink>
          <FixedNavbarLink to="/admin" icon="fas fa-user-cog" >Admin</FixedNavbarLink>
          <!--  -->
         
          <!-- <li class="nav-header">Master Data</li> -->
          
          
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
  </section>
</template>

<script>
import { computed } from 'vue'
import FixedNavbarLink from './FixedNavbarLink.vue';

export default {
  components: { FixedNavbarLink },
  setup(){
    const isActive = computed(() => {
      return window.location.pathname === '/schedule' || window.location.pathname === '/cleaning';
    })

    return {
      isActive,
    }
  }
  
}
</script>

<style>
.trijaya-green-color{
  background-color: #489464;
}
</style>